import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useBlogListingStore, { setBlogSearch, updateBlogFilters } from 'layout/Listing/variants/blog/store';

const useFilterSearchParam = () => {
  const router = useRouter();
  const activeFilters = useBlogListingStore(state => state.filters);
  const activeSearch = useBlogListingStore(state => state.search);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const search = params.get('s');
    const category = params.get('category');

    if (search) {
      setBlogSearch(search);
    }

    if (category && activeFilters === 'All') {
      updateBlogFilters(router, category);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (activeSearch) {
      params.set('s', activeSearch);
    } else {
      params.delete('s');
    }

    const basePath = router.asPath.split('?')[0];
    const newUrl = `${basePath}?${params.toString()}`;
    router.replace(newUrl, undefined, { shallow: true, scroll: false });
  }, [activeSearch]);
};

export default useFilterSearchParam;
